<template>
  <div class="p0 withdraw_wrapper">
    <div class="header_withdraw">
      <p>
        {{ $t("msg.available_balance") }}
        <span v-if="selectedBlue"
          >{{ bluAccount.balanceAvailable.toFixed(6) }} BLUE</span
        >
        <span v-else>{{ usdtAccount.balanceAvailable.toFixed(4) }} USDT</span>
      </p>
    </div>

    <div
      style="
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
        flex-direction: column;
      "
    >
      <div class="withdraw_steps_img">
        <img class="blu_balance_img" src="../../../../assets/images/1.png" />
      </div>
      <div
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          font-size: 9px;
        "
      >
        <div style="width: 60%; display: flex; justify-content: center">
          <span style="margin-left: 10px; color: #02b9a4">{{
            $t("msg.step_amount")
          }}</span>
          <span style="margin-left: 25px">{{ $t("msg.step_recipient") }}</span>
          <span style="margin-left: 25px">{{
            $t("msg.step_verification")
          }}</span>
          <span style="margin-left: 10px">{{
            $t("msg.step_authentication")
          }}</span>
        </div>
      </div>
    </div>

    <div class="redeem_form p0" v-if="selectedBlue">
      <div class="tal_c">
        <span class="text_m_blu">{{
          $t("msg.inform_the_amount_blu_tag")
        }}</span>

        <div class="column p0">
          <div
            class="column"
            v-bind:class="{
              has_error_color: !validation.amount || minBlue > bluAmount,
            }"
          >
            <p class="tal_c">
              {{ $t("msg.input_amount_withdraw") }}
            </p>

            <p class="tal_c" v-bind:class="{ notice: bluAmount < minBlue }">
              {{ $t("msg.min_amount_is") }}:
              {{ bluValue[0].withdrawMinimal }} BLUE
            </p>

            <div
              class="column blu_input_container_2"
              style="padding-bottom: 0 !important"
            >
              <img
                class="blu_input_img_2"
                src="../../../../assets/images/blue_icon.svg"
              />

              <div class="blu_input_2">
                <input
                  class="amount_redeem"
                  v-model="bluAmount"
                  v-on:keypress="isNumber()"
                  v-bind:class="{
                    has_error_color: !validation.amount || minBlue > bluAmount,
                  }"
                />
              </div>

              <div class="blu_input_actions">
                <div class="blu_input_plus" @click="modifyBluAmount('+')">
                  <p v-html="iconSets.general_up"></p>
                </div>
                <div
                  class="blue_input_minus"
                  @click="modifyBluAmount('-')"
                  v-bind:class="{
                    arrow_disabled:
                      parseFloat(bluAmount) <= parseFloat(minBlue),
                  }"
                >
                  <p v-html="iconSets.general_down"></p>
                </div>
              </div>
            </div>
            <p
              class="tal_c error_text_min"
              v-if="!validation.amount || bluAmount < minBlue"
            >
              <span class="text_sm has_error_text"
                >{{ $t("msg.invalid_amount") }}.</span
              >
            </p>
          </div>

          <div class="wrapper_withdraw_form">
            <div class="split-blocks">
              <div class="tag_container">
                <div
                  style="
                    width: 60%;
                    display: flex;
                    align-items: center;
                    justify-content: start;
                    text-align: left;
                    margin-right: 5px;
                    font-size: 0.9rem;
                  "
                >
                  <p v-html="$t('msg.send_to_blu_adress_on')"></p>
                </div>

                <div
                  class="balance_tag_reverse tab_black"
                  style="padding: 0rem 0.7rem"
                >
                  <img
                    src="../../../../assets/images/new-binance-chain-logo.png"
                  />
                </div>
              </div>
            </div>
            <div class="custom-flex">
              <div class="icon-container">
                <i v-html="iconSets.blu_wallet" class="icon_class_2 m_auto"></i>
              </div>

              <input
                class="amount_address"
                type="text"
                v-model="address"
                style="width: 100%"
                maxlength="42"
                @keyup="validateAdress(address)"
              />
            </div>

            <span
              class="fs_0001r"
              :class="(validation.address && address !== '') ? 'has_error_text' : ''"
            >
              {{ $t("msg.make_sure_address") }}
            </span>
          </div>

          <div v-if="modalWarn">
            <modal-warn-withdraw
              @closeModalWarnWithdraw="toggleModalWarn()"
              @understandWarnWithdraw="understandModalWarn()"
            ></modal-warn-withdraw>
          </div>

          <div class="wrapper_withdraw_form">
            <button
              class="btn_redeem"
              @click="callNextStep()"
              :disabled="onLoadValidation ? onLoadValidation : validation.address && validation.amount"
            >
              {{ $t("msg.next_step") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="redeem_form p0" v-else>
      <div class="tal_c">
        <span class="text_m_blu">{{ $t("msg.input_text_USDT") }}</span>

        <div class="column p0">
          <div
            class="column"
            v-bind:class="{
              has_error_color: !validation.amount || minUSDT > usdtAmount,
            }"
          >
            <p class="tal_c">{{ $t("msg.input_text_invalid_USDT") }}</p>

            <p class="tal_c" v-bind:class="{ notice: usdtAmount < minUSDT }">
              {{ $t("msg.min_amount_is") }}: 2 USDT
            </p>

            <div
              class="column blu_input_container_2"
              style="padding-bottom: 0 !important"
            >
              <img
                class="blu_input_img_2"
                src="../../../../assets/images/coins/coin_USDT.png"
              />

              <div class="blu_input_2">
                <input
                  class="amount_redeem"
                  v-model="usdtAmount"
                  v-on:keypress="isNumber()"
                  v-bind:class="{
                    has_error_color: !validation.amount || usdtAmount < minUSDT,
                  }"
                />
              </div>

              <div class="blu_input_actions">
                <div class="blu_input_plus" @click="modifyUSDTAmount('+')">
                  <p v-html="iconSets.general_up"></p>
                </div>
                <div
                  class="blue_input_minus"
                  @click="modifyUSDTAmount('-')"
                  v-bind:class="{
                    arrow_disabled: parseFloat(usdtAmount) <= minUSDT,
                  }"
                >
                  <p v-html="iconSets.general_down"></p>
                </div>
              </div>
            </div>
            <p
              class="tal_c error_text_min"
              v-if="!validation.amount || usdtAmount < minUSDT"
            >
              <span class="text_sm has_error_text"
                >{{ $t("msg.invalid_amount") }}.</span
              >
            </p>
          </div>

          <div class="wrapper_withdraw_form">
            <div class="split-blocks">
              <div class="tag_container">
                <div
                  style="
                    width: 70%;
                    display: flex;
                    align-items: center;
                    justify-content: start;
                    text-align: left;
                    font-size: 0.9rem;
                  "
                >
                  <p>{{ $t("msg.input_valid_usdt") }}:</p>
                </div>

                <div class="balance_tag_reverse tab_black">TRON (TRC20)</div>
              </div>
            </div>
            <div class="custom-flex">
              <div
                class="icon-container"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <span
                  class="icon_class_2_5 background_ val_m background_USDT"
                ></span>
              </div>

              <input
                class="amount_address"
                type="text"
                v-model="address"
                style="width: 100%"
                maxlength="34"
                @keyup="validateAdress(address)"
              />
            </div>

            <div>
              <span
              class="fs_0001r"
              :class="(validation.address && address !== '') ? 'has_error_text' : ''"
              style="text-align: left;"
            >
              <p>{{ $t("msg.usdt_info_trc20") }}</p>
          </span>
            </div>

            <div
              style="text-align: start; margin-top: 0.5rem"
              v-if="!selectedBlue"
            >
              <p>{{ $tc("msg.fee", 1) }}: 2 USDT</p>
            </div>
          </div>

          <div class="wrapper_withdraw_form">
            <button
              class="btn_redeem"
              @click="callNextStep()"
              :disabled="onLoadValidation ? onLoadValidation : validation.address || !validation.amount"
            >
              {{ $t("msg.next_step") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModalWarnWithdraw from "../../../modals/modalWarnWithdraw.vue";
import Swal from "sweetalert2";

export default {
  props: ["setAmount", "selectedPartner", "selectedBlue"],
  created() {
    this.checkAmount();
    this.getWithdrawFee();
    this.setMinAmount();
    this.validateAdress('');
    this.bluAmount = this.minBlue;
  },
  mounted() {},
  data: () => ({
    redeem_error: "",
    bluAmount: "",
    minBlue: "",
    usdtAmount: 2,
    minUSDT: 2,
    maxBluAmount: 99999999999,
    address: "",
    unLockedBalance: "",
    externalId: "",
    feeWithdraw: 0.01,
    validation: {
      amount: false,
      address: false,
    },
    tooltipBonus: false,
    modalWarn: false,
    amountToSend: 0,
    onLoadValidation: true,
  }),
  components: {
    ModalWarnWithdraw,
  },
  methods: {
    showToolTipBonus() {
      this.tooltipBonus = true;
    },
    hideToolTipBonus() {
      this.tooltipBonus = false;
    },
    getPartnerAddress() {
      if (this.selectedPartner == "stratum") {
        this.address = "NCYTV3UMZKBCIXXWGQPPH2QMSPL6L4FX67IGIP2J";
      } else if (this.selectedPartner == "stratumx") {
        this.address = "NAP55LGGGWPM37ZULDVOR5R6VHMFLT3XWWLGUFKI";
      }
    },
    setRedeemError() {
      if (this.bluAmount < this.minBlue) {
        this.redeem_error = "below_min";
      } else {
        this.redeem_error = "no_funds";
      }
    },

    callNextStep() {
      if (this.selectedBlue) {
        this.toggleModalWarn();

        this.amountToSend = this.bluAmount;
        if (this.amountToSend > this.bluAccount.balanceAvailable) {
          Swal.fire({
            icon: "error",
            title: this.$t("msg.error"),
            text: this.$t("msg.not_enough_balance"),
          });
          return;
        }
      } else {
        this.amountToSend = this.usdtAmount;
        if (this.amountToSend > this.usdtAccount.balanceAvailable) {
          Swal.fire({
            icon: "error",
            title: this.$t("msg.error"),
            text: this.$t("msg.not_enough_balance"),
          });
          return;
        }
      }

      if (this.validation.address) {
        Swal.fire({
          icon: "error",
          title: this.$t("msg.error"),
          text: this.$t("msg.invalid_address"),
        });
        return;
      }

      if (!this.selectedBlue) {
        this.$emit(
          "callNext",
          this.amountToSend,
          this.address,
          this.externalId
        );
      }
    },
    backToPartnerSelect() {
      this.$emit("backToPartners");
    },

    async getWithdrawFee() {
      let resp = await this.$store.dispatch("getFees");
      let fees = resp.data;

      let arrayFee = [];

      for (let i in fees) {
        if (fees[i].type == "withdraw") {
          arrayFee.push(fees[i].fee);
        }
      }
      this.feeWithdraw = arrayFee[arrayFee.length - 1];
    },

    xemToBlu(amount) {
      let xemToBlu = amount / this.bluValue[0].value;
      return xemToBlu;
    },

    setMinAmount() {
      let bluValue = this.btcValue[0].value / this.bluValue[0].value;
      this.minBlue = this.bluValue[0].withdrawMinimal;
      // this.bluAmount = this.minBlue;
    },

    checkAmount() {
      this.getUnlockedBalance();

      if (this.bluAmount >= 0 && this.bluAmount <= this.unLockedBalance) {
        this.validation.amount = true;
      } else {
        this.validation.amount = false;
      }
    },

    validateAmount() {
      this.bluAmountValid = false;
      let indices = [];
      let amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }
      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
      this.isNumberCheck();
    },

    isNumberCheck() {
      // let newBluAmount = [];
      // for (let i in this.bluAmount) {
      //   if (
      //     ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."].includes(
      //       this.bluAmount[i]
      //     )
      //   ) {
      //     newBluAmount.push(this.bluAmount[i]);
      //   }
      // }
      // newBluAmount = newBluAmount.join("");
      // this.bluAmount = newBluAmount;
      // var firstPosition = null;
      // if (newBluAmount.indexOf(".") > 1) {
      //   firstPosition = newBluAmount.indexOf(".");
      // }
      // if (firstPosition) {
      //   let newArray = [];
      //   for (let i in this.bluAmount) {
      //     if (i == firstPosition) {
      //       newArray.push(".");
      //     } else {
      //       if (!isNaN(this.bluAmount[i])) {
      //         newArray.push(this.bluAmount[i]);
      //       }
      //     }
      //   }
      //   newArray = newArray.join("");
      //   this.bluAmount = parseFloat(newArray);
      // }
      // if (this.bluAmount == ".") {
      //   this.bluAmount = "0";
      // }
    },

    getUnlockedBalance() {
      if (this.bluAccount) {
        let totalBalance = this.bluAccount.balance;
        let lockedBalace = this.bluAccount.locked;
        let unLockedBalance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
      }
    },

    validateAdress(address) {
      const pattern = /[(){}[\]\s/^~<>?:;|!@#$%¨&*=+'".,_-]/
      const result = event.target.value.replace(pattern, '');
      this.address = result;

      if (this.selectedBlue) {
        if (
          address.length > 41 &&
          address.charAt(0) === "0" &&
          address.charAt(1) === "x"
        ) {
          this.validation.address = false;
        } else {
          this.validation.address = true;
        }
      } else {
        var WAValidator = require("multicoin-address-validator");
        let valid = WAValidator.validate(address, "trx");

        console.log(valid);
        this.validation.address = !valid;
      }
    },

    modifyBluAmount(modifier) {
      if (
        this.bluAmount == false ||
        this.bluAmount < this.minBlue ||
        this.bluAmount == ""
      ) {
        this.bluAmount = this.minBlue;
      } else {
        let vm = this;
        if (modifier == "-" && this.bluAmount > 0) {
          let result = this.bluAmount - 1;
          if (result > this.minBlue) {
            this.bluAmount = vm.roundUp(this.bluAmount - 1, 3);
          } else {
            this.bluAmount = vm.roundUp(vm.minBlue, 3);
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = parseFloat(this.bluAmount) + 1;
          this.bluAmount = vm.roundUp(this.bluAmount, 3);
        }
      }
    },

    modifyUSDTAmount(modifier) {
      if (
        this.usdtAmount == false ||
        this.usdtAmount < this.minUSDT ||
        this.usdtAmount == ""
      ) {
        this.usdtAmount = this.minUSDT;
      } else {
        let vm = this;
        if (modifier == "-" && this.usdtAmount > 0) {
          let result = this.usdtAmount - 1;
          if (result > this.minUSDT) {
            this.usdtAmount = vm.roundUp(this.usdtAmount - 1, 3);
          } else {
            this.usdtAmount = vm.roundUp(vm.minUSDT, 3);
          }
        } else if (modifier == "+" && this.usdtAmount < this.maxBluAmount) {
          this.usdtAmount = parseFloat(this.usdtAmount) + 1;
          this.usdtAmount = vm.roundUp(this.usdtAmount, 3);
        }
      }
    },

    roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },

    isNumber() {
      let evt = window.event;
      var charCode = evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    switchMode() {
      this.$emit("switchMode");
    },
    toggleModalWarn() {
      this.modalWarn = !this.modalWarn;
    },
    understandModalWarn() {
      this.$emit("callNext", this.amountToSend, this.address, this.externalId);
    },
  },
  computed: {
    ...mapGetters([
      "btcValue",
      "bluValue",
      "usdtValue",
      "bluAccount",
      "usdtAccount",
      "ethValue",
      "xemValue",
      "rasValue",
    ]),
  },
  watch: {
    bluAmount: function () {
      this.setRedeemError();
      this.validateAmount();
      this.checkAmount();
    },

    feeWithdraw: function () {
      this.setMinAmount();
    },

    minBlue: function () {
      this.bluAmount = this.minBlue;
    },

    selectedBlue: function () {
      this.address = "";
    },
    
    address() {
      this.onLoadValidation = false
      this.validateAdress(this.address)
    }
  },
};
</script>
<style scoped>
.icon-container {
  background: white;
  width: 70px;
  border-style: solid;
  border-width: 1px 0px 1px 1px;
  border-color: #e3d4d4;
  display: flex;
}

.withdraw-step1 {
  display: flex;
  color: #363636;
  margin-bottom: 12px;
}

.copy-clip {
  display: flex;
  color: #60609b;
  justify-content: space-around;
}

.split-blocks {
  margin-bottom: 12px;
}

.bsc-info {
  display: flex;
  justify-content: space-between;
}

.instructs {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 18px;
  border-top: 1px solid #d8d6d6;
  border-bottom: 1px solid #d8d6d6;
}
.or {
  text-align: center;
}
.step {
  width: 85%;
  margin-bottom: 18px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/private/services/withdraw_steps/WithdrawStep03.vue